import { render, staticRenderFns } from "./DayAgendaListItemPlaceholder.vue?vue&type=template&id=0446131a&scoped=true"
import script from "./DayAgendaListItemPlaceholder.vue?vue&type=script&lang=js"
export * from "./DayAgendaListItemPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./DayAgendaListItemPlaceholder.vue?vue&type=style&index=0&id=0446131a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0446131a",
  null
  
)

export default component.exports